import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IDesignation {
designation_id:number,
designation_name:string,
is_active:boolean
}

interface IDesignationData {
    list?: Array<IDesignation>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IDesignationData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const designationSlice = createSlice({
    name: "designation",
    initialState,
    reducers: {
        setDesignationList: (state, _action: PayloadAction<IDesignationData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetDesignationToInit: (state) => {
            state = initialState;
        },
        setDesignationMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setDesignationList, resetDesignationToInit, setDesignationMessage } = designationSlice.actions;

export default designationSlice.reducer;

